module.exports = __webpack_public_path__ + "img/A57-20190408_06(1).cbbf79c7.png";